export default __webpack_public_path__ + "static/media/play_arrow_white_48dp.07e5e865.svg";